export class Answer {
    constructor(answerState) {
        this.answerState = answerState;
    }
    get id() {
        return this.answerState.id;
    }
    get userId() {
        return this.answerState.userId;
    }
    get questionId() {
        return this.answerState.questionId;
    }
    get answerDate() {
        return this.answerState.answerDate;
    }
    getState() {
        return this.answerState;
    }
}
